import React from "react";
import "./Education.css";   

function Education(){
    return(
         <div className="eduContainer">
                <div className="eduleft">
                    <p>Bachlelor</p>
                    <p><strong>Computer Science</strong></p>
                    <p>Jimma University</p>
                    <p>GPA: 3.45</p>
                </div>
                <div className="eduright">
                    <p className="july2024">July 2024 </p>
                    <p>Graduation Date</p>
                </div>
            </div>
    )
}

export default Education;